export default "__VITE_ASSET__886e6167__"